import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

import Loader from '../Common/Loader';

import { logsService } from '../../Services';
 
const SLOT_COLORS = [
  "#F04438", 
  "#F79009",
  "#12B76A",
];

const generateEvents = (teams, schedule, users) => {
    const events = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const endDate = new Date(today);
    endDate.setDate(endDate.getDate() + 90);
    
    const weekdaySlotMap = {};
    
    teams.forEach((team) => {
        const jsDay = sqlWeekdayToJS(team.Weekday);
        if (!weekdaySlotMap[jsDay]) weekdaySlotMap[jsDay] = [];
        weekdaySlotMap[jsDay].push(team.TeamID);
    });
    
    teams.forEach((team) => {
        const jsDay = sqlWeekdayToJS(team.Weekday);

        const cursor = new Date(today);
        const diff = (jsDay - cursor.getDay() + 7) % 7;
        cursor.setDate(cursor.getDate() + diff);

        while (cursor <= endDate) {
            const y = cursor.getFullYear();
            const m = String(cursor.getMonth() + 1).padStart(2, '0');
            const d = String(cursor.getDate()).padStart(2, '0');
            const dateStr = `${y}-${m}-${d}`;

            if (cursor < today) {
                cursor.setDate(cursor.getDate() + 7);
                continue;
            }

            let divers = team.divers;
            let presenters = users ? Object.values(users).filter(item => item.PresentationDiver === 1 && item.Team === team.TeamID).length : 0;
            if (schedule) {
                schedule
                    .filter((s) => s.TeamID === team.TeamID && s.DiveDate && s.DiveDate === dateStr)
                    .forEach((s) => {
                        if (s.WillAttend === 0 && users[s.UserID]?.Team === s.TeamID) {
                            divers -= 1;
                            if (users[s.UserID]?.PresentationDiver) presenters -= 1;
                        }
                        else if (s.WillAttend === 1 && users[s.UserID]?.Team !== s.TeamID) {
                            divers += 1;
                            if (users[s.UserID]?.PresentationDiver) presenters += 1;
                        }
                    });
            }

            const color = divers < 3 ? SLOT_COLORS[0] : divers < 6 ? SLOT_COLORS[1] : SLOT_COLORS[2];

            events.push({
                id: `${team.TeamID}-${dateStr}`,
                title: `${team.Team}: ${team.weekday} ${team.TeamStartTime} - ${team.TeamEndTime}`,
                start: `${dateStr}T${team.StartTime}`,
                end:   `${dateStr}T${team.EndTime}`,
                backgroundColor: color,
                borderColor: color,
                extendedProps: {
                    teamId: team.TeamID,
                    team: team.Team,
                    date: dateStr,
                    description: team.TeamDescription,
                    omid: team.omid,
                    divers: divers,
                    presenters: presenters
                },
            });

            cursor.setDate(cursor.getDate() + 7);
        }
    });
    
    return events;
}
    
const sqlWeekdayToJS = (sqlDay) => {
    return sqlDay - 1;
}

const today = new Date();
today.setHours(0, 0, 0, 0);
const endDate = new Date(today);
endDate.setDate(endDate.getDate() + 91);

export const Schedule = () => {
    const [events, setEvents] = useState([]);
    const [userSchedule, setUserSchedule] = useState({});
    const [loading, setLoading] = useState();
    const navigate = useNavigate();
    const local = useSelector((state) => state.org.remember);
    const is24h = useSelector((state) => state[local ? 'localUser' : 'user'].is24h);
    const name = useSelector((state) => state[local ? 'localUser' : 'user'].name);

    const handleEventClick = ({ event }) => {
        navigate(`/schedule/${event._def.extendedProps.teamId}/${event._def.extendedProps.date}`);
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            const res = await logsService.getSchedule();

            if (!res.error) {
                setEvents(generateEvents(res.list, res.schedule, res.users));
                setUserSchedule(res.userSchedule);
            }

            setLoading(false);
        };

        fetchData();
    }, []);

    return (
        <>
            {loading ? <Loader /> :  <>
                <h1>Schedule dives</h1>
                {userSchedule.permission ? <div className={`orgs-alert ${parseInt(userSchedule.count) === 0 ? 'red' : 'orange'}`}>
                    {name}, you are currently signed up for {userSchedule.count} dive(s) next month.<br />
                    Please remember to sign up for a minimum of 4 dives before or on the 20th of each month.
                </div> : ''}
                <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    initialView="dayGridMonth"
                    headerToolbar={{
                        left: "prev,next today",
                        center: "title",
                        right: "dayGridMonth,timeGridWeek,timeGridDay",
                    }}
                    buttonText={{
                        today: "Today",
                        month: "Month",
                        week:  "Week",
                        day:   "Day",
                    }}
                    events={events}
                    eventClick={handleEventClick}
                    validRange={{ start: today, end: endDate }}
                    dayMaxEvents={3}
                    nowIndicator={true}
                    height="auto"
                    slotMinTime="07:00:00"
                    slotMaxTime="21:00:00"
                    displayEventTime={false}
                    eventDisplay="block"
                    slotLabelFormat={{
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: !is24h
                    }}
                    eventContent={(arg) => (
                        <div style={{ whiteSpace: 'normal', padding: '1px 3px', fontSize: '0.85em' }}>
                            {arg.event.title}<br />{arg.event.extendedProps.divers} divers, {arg.event.extendedProps.presenters} presenters
                        </div>
                    )}
                />
            </>
        }
        </>
    )
}

export default Schedule;